"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePosition = void 0;
const tslib_1 = require("tslib");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
const ImageWidget_1 = tslib_1.__importDefault(require("../../widget/ImageWidget"));
// IF YOU USE OR EXTEND THIS CLASS MAKE SURE YOU HAVE A LABEL FOR THE INPUT OR GIVE THE INPUT THE aria-label ATTRIBUTE
// Component rendered in the user interface
// <div style="display: flex; flex-direction: row">
//   <src="*.svg" alt="image-description">
//   <input type="text">
// </div>
// or
// <div style="display: flex; flex-direction: row">
//   <input type="text">
//   <src="*.svg" alt="image-description">
// </div>
/**
 * @deprecated Use {@link LabeledInputFieldWithImageWidget} instead.
 */
class TextFieldWithImage extends InputWidget_1.default {
    constructor(textFieldWithImageArgs) {
        super(document.createElement("input"), true, false);
        this.textFieldWithImageArgs = textFieldWithImageArgs;
        this.decorateElement(this._input);
    }
    getImageWidget() {
        return this.imageWidget;
    }
    parseValueFromInput(inputValue) {
        return inputValue;
    }
    setValueOnInput(value, input) {
        input.value = value;
    }
    decorateElement(input) {
        const { imageSrc, imageAlt, fieldSizeClass, imagePosition = ImagePosition.BEFORE } = this.textFieldWithImageArgs;
        this.element = document.createElement("div");
        this.imageWidget = new ImageWidget_1.default({ src: imageSrc, alt: imageAlt });
        input.type = "text";
        if (fieldSizeClass) {
            input.classList.add(fieldSizeClass);
        }
        this.element.classList.add("form-control", "image-input-form");
        // Prevent input from blinking if it is already in focus and we click on something other that input field
        this.element.addEventListener("mousedown", event => {
            if (document.activeElement === input) {
                event.preventDefault();
                return;
            }
        });
        this.element.addEventListener("click", event => {
            if (event.target !== input) {
                input.click();
            }
        });
        input.addEventListener("focus", () => input.select());
        if (imagePosition === ImagePosition.BEFORE) {
            this.add(this.imageWidget);
            this.add(input);
        }
        else if (imagePosition === ImagePosition.AFTER) {
            this.add(input);
            this.add(this.imageWidget);
        }
    }
}
exports.default = TextFieldWithImage;
var ImagePosition;
(function (ImagePosition) {
    ImagePosition[ImagePosition["BEFORE"] = 0] = "BEFORE";
    ImagePosition[ImagePosition["AFTER"] = 1] = "AFTER";
})(ImagePosition = exports.ImagePosition || (exports.ImagePosition = {}));
//# sourceMappingURL=TextFieldWithImage.js.map